import { Form, Grid, Label } from 'semantic-ui-react';
import styled from 'styled-components';

const DrawerFooter = styled(Form.Field)`
  margin-top: 2rem !important;
  float: right;
`;

const StyledLabel = styled(Label) <{ labelMargin?: number }>`
white-space: normal;
background: #fff!important;
border: 1px solid #e0b4b4!important;
color: #9f3a38!important;
margin-top: ${props => props.labelMargin ? `${props.labelMargin}px` : '10px'} !important;
margin-bottom: 10px !important;
`
const StyledGrid = styled(Grid)`
 label {
  font-weight: bold !important;
 }
`

export const UserEl = {
  DrawerFooter,
  StyledLabel,
  StyledGrid
};
